export default __webpack_public_path__ + "static/media/bag.8ace2563.jpeg";